<title>{{ KnownIssuesPage.htmlTitle }}</title>
<app-known-issues-section [sections]="KnownIssuesPage.sections"></app-known-issues-section>
<app-known-issues-table-section [tableSections]="KnownIssuesPage.tableSections"></app-known-issues-table-section>

<ng-template [ngIf]="subscribeUrl">
  <div class="subscribeLink">
    <button class="subscribeMe">
      <i class="fa fa-envelope"></i>
      <a [href]="subscribeUrl">Subscribe Notifications</a>
    </button>
  </div>
</ng-template>
